import React from 'react'
import Routes from './Routes'

const App = () => {
  return (
    <Routes id="App" />
  )
}

export default App
